import * as React from 'react';
import UHDRSFunctionalAssessmentHistory from './HistoryRowData/UHDRSFunctionalAssessment';
import UHDRSIndependenceScaleHistory from './HistoryRowData/UHDRSIndependenceScale';
import UHDRSFunctionalCapacityHistory from './HistoryRowData/UHDRSFunctionalCapacity';
import ModifiedRankinScaleHistory from './HistoryRowData/ModifiedRankinScale';
import ModifiedChildrensGlobalAssessmentScaleHistory from './HistoryRowData/ModifiedChildrensGlobalAssessmentScale';
import { getHeaderId } from '../utils';
import type { TFunctionalPerformanceDocumentType } from '../utils';
import FormEditingHandler from 'Containers/FormEditingHandler';
import DocumentWrapper from 'Components/DocumentWrapper';
import DocumentHeader from 'Components/DocumentHeader';
import Form from './Form';
import PlatformConditional from 'Components/PlatformConditional';
import { filterByDocumentType } from 'Utility/documentHandling';

const FunctionalPerformanceHistory = (
  documents: Array<IDocumentWithTypeV2<TFunctionalPerformanceDocumentType>>,
  startEdit: StartEdit,
  view?: IView,
): React.JSX.Element => {
  const UHDRSFunctionalAssessmentDocs = filterByDocumentType(documents, 'uhdrsFunctionalAssessment');
  const UHDRSIndependenceScaleDocs = filterByDocumentType(documents, 'uhdrsIndependenceScale');
  const UHDRSFunctionalCapacityDocs = filterByDocumentType(documents, 'uhdrsFunctionalCapacity');
  const modifiedRankinScaleDocs = filterByDocumentType(documents, 'modifiedRankinScale');
  const modifiedChildrensGlobalAssessmentScaleDocs = filterByDocumentType(
    documents,
    'modifiedChildrensGlobalAssessmentScale',
  );

  return (
    <React.Fragment>
      <PlatformConditional platform="huntington">
        <React.Fragment>
          <UHDRSFunctionalAssessmentHistory
            documents={UHDRSFunctionalAssessmentDocs}
            startEdit={startEdit}
            view={view}
          />
          <UHDRSIndependenceScaleHistory documents={UHDRSIndependenceScaleDocs} startEdit={startEdit} view={view} />
          <UHDRSFunctionalCapacityHistory documents={UHDRSFunctionalCapacityDocs} startEdit={startEdit} view={view} />
        </React.Fragment>
      </PlatformConditional>
      <PlatformConditional platform="epilepsy">
        <React.Fragment>
          <ModifiedRankinScaleHistory documents={modifiedRankinScaleDocs} startEdit={startEdit} view={view} />
          <ModifiedChildrensGlobalAssessmentScaleHistory
            documents={modifiedChildrensGlobalAssessmentScaleDocs}
            startEdit={startEdit}
            view={view}
          />
        </React.Fragment>
      </PlatformConditional>
    </React.Fragment>
  );
};

const FunctionalPerformance = ({ documents }: IOwnProps): React.JSX.Element => (
  <FormEditingHandler name="functionalPerformance" documents={documents}>
    {(editing, startEdit, formData, view): React.JSX.Element => (
      <DocumentWrapper>
        <DocumentHeader
          name="functionalPerformance"
          headerId={getHeaderId(documents, editing, view?.viewing)}
          editing={editing}
          editButtons={<div />}
        />
        {editing ? <Form formData={formData} document={documents.find(d => d._id === editing)} /> : null}
        {view?.viewing ? (
          <Form
            formData={{ document: view.document, onChange: (): string => '' }}
            document={documents.find(d => d._id === view.viewing)}
            viewing={!!view.viewing}
          />
        ) : null}
        {!editing && !view?.viewing ? FunctionalPerformanceHistory(documents, startEdit, view) : undefined}
      </DocumentWrapper>
    )}
  </FormEditingHandler>
);

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<TFunctionalPerformanceDocumentType>>;
}

export default FunctionalPerformance;
